module.exports = __webpack_public_path__ + "img/table.85392ff8.jpg";